/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>经销商资料</el-breadcrumb-item>
      <el-breadcrumb-item>驻村代表信息</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form class="user-search">
          <el-form-item>
            <el-button size="small" type="primary" @click="goback">返回</el-button>
          </el-form-item>
        </el-form>
        <div class="titlelist"><div class="icons"></div>人员信息</div>
		<div class="listout">
			<div class="list">
				<div class="listleft">名称：{{list.name}}</div>
			</div>
			<div class="list">
				<div class="listleft">手机号：{{list.mobile}}</div>
			</div>
			<div class="list">
				<div class="listleft">申请地区：{{list.area}}</div>
			</div>
			<div class="list">
				<div class="listleft">创建时间：{{list.createTime}}</div>
			</div>
		</div>
		
		<div class="titlelist"><div class="icons"></div>经销商信息</div>
		<div class="listout">
			<div class="lists">
				<div class="listleft">名称：{{list.dealersName}}</div>
			</div>
			<div class="lists">
				<div class="listleft">手机号：{{list.dealersMobile}}</div>
			</div>
			
		</div>
		
		
		
		
      </div>
    </template>

    <script>
    import {
      getzcdbById,
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
          list:''
         
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        //this.getData(this.formProInfo)

      },
      mounted(){
		  this.id = this.$route.query.id
		  this.handleEdit()
		  
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		
		  //显示编辑界面
		  handleEdit: function() {
		    let _this = this
		   
		   getzcdbById(this.id).then(res => {
		       console.log(res)
		       this.loading = false
		       if (res.success == false) {
		         this.$message({
		           type: 'info',
		           message: res.msg+'TraceId:'+res.traceId
		         })
		       } else {
		         console.log(res)
		         this.list = res.data
					 
				 }
				 
		   		  
		         
		     })
		   
		   
		  },
		 
		//编辑
		goback() {
			this.$router.push({ path: '/residency'})
		 
		},
		

      }
    }
    </script>

    <style scoped>
	.listout{
		width: 96%;
		display: flex;
		margin: 0 auto;
		margin-top: 20px;
	}
	.list{
		width: 25%;
		height: 20px;
		line-height: 20px;
		text-align: left;
	}
	.lists{
		width: 40%;
		height: 20px;
		line-height: 20px;
		text-align: left;
	}
	.titlelist{
		margin: 0 auto;
		height: 30px;
		text-align: left;
		line-height: 30px;
		margin-top: 40px;
		padding-left: 10px;
		width: 96%;
		position: relative;
	}
	.icons{
		height: 22px;
		width: 4px;
		border-radius: 10px;
		background-color: #000;
		position: absolute;
		left: 0;
		top: 4px;
	}
    .user-search {
		position: absolute;
		top: 20px;
		right: 0px;
		width: 100px;
    }
	.user-searchs {
	  margin-top: 20px;
	}
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
		height: 85%;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .editForm{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 600px;
	  
  }
  .el-select{
	  width: 100%;
  }
  .dialog-footer{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 480px;
	  padding-left: 120px;
  }
  .title{
	  width: 100%;
  }
    </style>





// WEBPACK FOOTER //
// src/views/staffmanagement/residencyadd.vue